define('controllers/hoteldetailssearch',['require'],function(require) {
    return function() {
        var searchBox = $("#txtSearch"),
        loading = $("#loading"),
        results = $("#results");

        $("#btnSearch").on("click", function () {
            var searchPhrase = searchBox.val();

            loading.show();
            $.ajax({
                type: 'POST',
                url: "/mvc/Search/SearchHotelDetails",
                data: { searchPhrase: searchPhrase },
                success: function (detailsResults) {
                    results.html(detailsResults);

                    $("#results .btn").off("click").on("click", function () {
                        console.log($(this).parent().next());
                        $(this).next().fadeToggle('fast');
                    });
                },
                complete: function () {
                    loading.hide();
                }
            });
        });

        $("#toggleAll").on("click", function () {
            $(".detailContent").toggle();
        });
    };
});

